import { DefaultFileHandler, FileHandlerConfiguration, FileService } from '@philips-internal/oswald-ui-components';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { LayoutData } from '../app/types';
import { Endpoint } from '../constants/endpoints';

class ConfigurationService {

  static getLayoutConfigurationData(): Promise<LayoutData> {
    return HttpService.get(Endpoint.LAYOUT_CONFIGURATION).then(response => response.body as LayoutData);
  }

  static setFileuploaderConfig(): void {

    const config = new FileHandlerConfiguration();

    const handler = new DefaultFileHandler();
    handler.setConfiguration(config);

    FileService.setFileHandler(handler);
  }
}

export default ConfigurationService;